import { render, staticRenderFns } from "./VimeoVideos.vue?vue&type=template&id=03cdda27&scoped=true&"
import script from "./VimeoVideos.vue?vue&type=script&lang=js&"
export * from "./VimeoVideos.vue?vue&type=script&lang=js&"
import style0 from "./VimeoVideos.vue?vue&type=style&index=0&id=03cdda27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cdda27",
  null
  
)

export default component.exports